import Topbar from "@/components/layout/Topbar";
import TransportistasTab from "@/components/rec/TransportistasTab";

export default function TransportistasPage() {
  return (
    <>
      <Topbar
        title="Transportistas"
        subtitle="Titulares de carta de porte y transportistas registrados en AFIP/SENASA."
      />
      <div className="p-4" data-testid="transportistas-page">
        <TransportistasTab />
      </div>
    </>
  );
}
